<template>
  <div class="d-flex justify-content-center mb-4">
    <ul class="nav nav-pills nav-justified fitness-tabs">
      <li class="nav-item">
        <button
          class="nav-link"
          :class="{ active: activeTab === 'overview' }"
          @click="$emit('tab-change', 'overview')"
        >
          <i class="bi bi-bar-chart-line me-2"></i>Overview
        </button>
      </li>
      <li class="nav-item">
        <button
          class="nav-link"
          :class="{ active: activeTab === 'exercise' }"
          @click="$emit('tab-change', 'exercise')"
        >
          <i class="bi bi-lightning-charge me-2"></i>Exercise
        </button>
      </li>
      <li class="nav-item">
        <button
          class="nav-link"
          :class="{ active: activeTab === 'nutrition' }"
          @click="$emit('tab-change', 'nutrition')"
        >
          <i class="bi bi-apple me-2"></i>Nutrition
        </button>
      </li>
      <li class="nav-item">
        <button
          class="nav-link"
          :class="{ active: activeTab === 'challenges' }"
          @click="$emit('tab-change', 'challenges')"
        >
          <i class="bi bi-trophy me-2"></i>Challenges
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'FitnessNavigation',
  props: {
    activeTab: {
      type: String,
      required: true,
    },
  },
  emits: ['tab-change'],
}
</script>

<style scoped>
.fitness-tabs {
  max-width: 700px;
  width: 100%;
}

.fitness-tabs .nav-item {
  flex: 1;
}

.fitness-tabs .nav-link {
  padding: 12px 16px;
  margin: 0 2px;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  border: none;
  background: transparent;
  color: #6c757d;
  transition: all 0.3s ease;
}

.fitness-tabs .nav-link:hover {
  background-color: rgba(233, 30, 99, 0.1);
  color: var(--primary-color);
}

.fitness-tabs .nav-link.active {
  background-color: var(--primary-color) !important;
  color: white !important;
}

@media (max-width: 768px) {
  .fitness-tabs .nav-link {
    padding: 10px 8px;
    font-size: 0.9rem;
  }

  .fitness-tabs .nav-link i {
    font-size: 0.9rem;
  }
}

@media (max-width: 576px) {
  .fitness-tabs .nav-link {
    padding: 8px 4px;
    font-size: 0.8rem;
    flex-direction: column;
    gap: 2px;
  }

  .fitness-tabs .nav-link i {
    margin: 0 !important;
    font-size: 0.8rem;
  }
}
</style>
